<ng-template #translationModal let-modal>
  <div>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Translation</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="onCloseModal()"
              title="Close Modal"></button>
    </div>

    <div class="modal-body body-padding" [style.max-height.px]="modalHeight" [style.min-height.px]="modalHeight">
      <div class="col-sm-3 ms-2">
        <label class="data-label">Language</label>
        <app-select [options]="language" [selectClass]="'ng-form-select primary-select'"
                    selectPlaceholder="Language" [(selectedValue)]="typeSelect"></app-select>
      </div>
      <div class="post-content-wrap">
        <div class="post-comp-block {{element.elementId === articleElementType.SubLine?'subline-block-spacing':
        element.elementId=== articleElementType.Header?'header-block-spacing':''}}" *ngFor="let element of articleData; let i = index; trackBy: identify">
          <div class="drop-thumb-wrapper" [ngSwitch]="element.elementId">
            <!-- Article Header element edit/view box -->
            <div *ngSwitchCase="articleElementType.Header">
              <label class="title-text mb-2">Header</label>
              <div class="mb-2 fs-6 fw-normal">
                <ng-component [innerHTML]="element?.displayHtml"></ng-component>
              </div>
              <app-article-header [blockElement]="element" (blockElementChange)="updateElement($event, i)"></app-article-header>
            </div>

            <!-- Article Text element edit/view box -->
            <div class="mt-3" *ngSwitchCase="articleElementType.Text">
              <label class="title-text mb-2">Text</label>
              <div class="mb-2 fs-6 fw-normal">
                <ng-component [innerHTML]="element?.displayHtml"></ng-component>
              </div>
              <app-article-paragraph [blockElement]="element" (blockElementChange)="updateElement($event, i)"></app-article-paragraph>
            </div>

            <!-- Article List element edit/view box -->
            <div class="mt-3" *ngSwitchCase="articleElementType.List">
              <label class="title-text mb-2">List</label>
              <div class="mb-2 fs-6 fw-normal">
                <ng-component [innerHTML]="element?.displayHtml"></ng-component>
              </div>
              <app-article-list [blockElement]="element" (blockElementChange)="updateElement($event, i)"
                                (openHighLightButtonClick)="openHighLightModel($event)"></app-article-list>
            </div>

            <!-- Article Subline element edit/view box -->
            <div class="mt-3" *ngSwitchCase="articleElementType.SubLine">
              <label class="title-text mb-2">SubLine</label>
              <div class="mb-2 fs-6 fw-normal">
                <ng-component [innerHTML]="element?.displayHtml"></ng-component>
              </div>
              <app-article-subline [blockElement]="element" (blockElementChange)="updateElement($event, i)"></app-article-subline>
            </div>

            <!-- Article quote element edit/view box -->
            <div class="mt-3" *ngSwitchCase="articleElementType.Quote">
              <label class="title-text mb-2">Quote</label>
              <div class="mb-2 fs-6 fw-normal">
                <ng-component [innerHTML]="element?.displayHtml"></ng-component>
              </div>
              <app-article-quote [blockElement]="element" (blockElementChange)="updateElement($event, i)"></app-article-quote>
            </div>

            <!-- Article lead element edit/view box -->
            <div class="mt-3" *ngSwitchCase="articleElementType.Lead">
              <label class="title-text mb-2">Lead</label>
              <div class="mb-2 fs-6 fw-normal">
                <ng-component [innerHTML]="element?.displayHtml"></ng-component>
              </div>
              <app-article-lead [blockElement]="element" (blockElementChange)="updateElement($event, i)"></app-article-lead>
            </div>

            <!-- Article Link element edit/view box -->
            <div class="mt-3" *ngSwitchCase="articleElementType.Link">
              <label class="title-text mb-2">Link</label>
              <div class="mb-2 fs-6 fw-normal">
                <ng-component [innerHTML]="element?.displayHtml"></ng-component>
              </div>
              <app-article-link [blockElement]="element" (blockElementChange)="updateElement($event, i)"></app-article-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer content-end">
      <button class="btn btn-outline-primary" (click)="openCancelTransactionModal(cancelTranslationModal)">Cancel</button>
      <button class="btn btn-primary btn-radius" (click)="openSaveTransactionModal(saveTranslationModal)">Confirm</button>
    </div>
  </div>
</ng-template>

  <ng-template #cancelTranslationModal let-modal>
    <div class="modal-head">
      <!--<button class="btn btn-close" (click)="modal.dismiss('Cross click')"></button>-->
    </div>
    <div class="modal-body text-center">
      <h2 class="confirm-title-text">Cancel Translation</h2>
      <h5 class="confirm-info-text">There are some edits on this page.Are you sure you want to cancel the translation?</h5>
      <div class="btn-grps">
        <button class="btn btn-outline-primary" title="No" (click)="modal.close(false)">Cancel</button>
        <button class="btn btn-primary btn-radius ms-2" (click)="modal.close(true)" title="Yes">Proceed</button>
      </div>
    </div>
  </ng-template>

  <ng-template #saveTranslationModal let-modal>
    <div class="modal-head">
      <!--<button class="btn btn-close" (click)="modal.dismiss('Cross click')"></button>-->
    </div>
    <div class="modal-body text-center">
      <h2 class="confirm-title-text">Save Translation</h2>
      <h5 class="confirm-info-text">Please confirm that the translation is correct and that you would like to save it</h5>
      <div class="btn-grps">
        <button class="btn btn-outline-primary" title="No" (click)="modal.close(false)">Cancel</button>
        <button class="btn btn-primary btn-radius ms-2" (click)="modal.close(true)" title="Yes">Proceed</button>
      </div>
    </div>
  </ng-template>
